import { MinimumsEditorRoot } from 'modules/Cube/view/common/drawers/minimumEditor/drawer/content/MinimumEditorRoot'
import { useMinimumsEditorConnector } from 'modules/Cube/view/common/drawers/minimumEditor/useMinimumEditor.connector'

export const MinimumsEditorCubeRoute = () => {
  const routeConnectorHook = useMinimumsEditorConnector()
  return <MinimumsEditorRoot {...routeConnectorHook} />
}
